import { Blocks, Seo } from 'components'
import { graphql } from 'gatsby'
import camelCase from 'lodash.camelcase'
import React from 'react'
// import { Helmet } from 'react-helmet'

import * as TempData from '../temp/data'

const PageTemplate = ({ data }) => {
  const page = data.wpPage

  // Todo refactor this (pageName) function
  const pageName =
    camelCase(page.title).charAt(0).toUpperCase() +
    camelCase(page.title).slice(1)

  // const layouts = data.wpPage.pageBuilder.layouts || []
  const tempLayouts = TempData[pageName] || []

  return (
    <>
      <Seo title={page ? page.title : null} />

      {/* Todo: Implement the layouts on wordpress when it's done */}
      {/* {(page.pageBuilder.layouts || []).map((layout, index) => (
        <Blocks key={`block_${index}`} data={layout} />
      ))} */}

      {(tempLayouts || []).map((layout, index) => (
        <Blocks key={`block_${index}`} data={layout} />
      ))}
    </>
  )
}

export const query = graphql`
  query GET_PAGE($id: String!) {
    wpPage(id: { eq: $id }) {
      id
      slug
      title
      pageBuilder {
        fieldGroupName
        layouts {
          __typename
          ... on WpPage_Pagebuilder_Layouts_Hero {
            kicker
            heading
            text
            buttons {
              label
              type
              destination {
                __typename
                ... on WpPage {
                  uri
                }
              }
            }
            featuredImage {
              altText
              description
              title
              localFile {
                publicURL
                childImageSharp {
                  gatsbyImageData(
                    width: 1200
                    placeholder: DOMINANT_COLOR
                    layout: FULL_WIDTH
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
            }
            clients
          }
        }
      }
    }
  }
`
export default PageTemplate
